<template>
    <div>
    <footer class="hide_xs">
      <nav class="footer_content">
        <div class="col-xs-12 col-sm-12 col-md-12 footer-body">
            <div class="col-xs-12 col-sm-12 col-md-12 center col-gap-50">
              <div @click="openSaasModal('sass')" class="footer-text">
                  {{$t('termsAndConditions')}}
              </div>
              <div @click="openSaasModal('termsOfUse')" class="footer-text">
                {{$t('paymentTerms')}}
              </div>
              <div class="footer-text" @click="openSaasModal('privacyPolicy')">
                  {{$t('privacyPolicy')}}
              </div>
            </div>
        </div>
      </nav>
    </footer>
    </div>
</template>
<script>
import * as moment from 'moment';

export default {
  data() {
    return {
      agreementType: '',
    };
  },
  components: {
    // NotificationBanner,
  },
  methods: {
    openSaasModal(data) {
      this.$emit('openModal', data);
    },
    getFullYear() {
      return moment().format('YYYY');
    },
  },
};
</script>

<style scoped>
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-gap-50 {
  column-gap: 50px;
}
.align-left {
  text-align: left;
}
.align-right {
  text-align: right;
}
.pl-9 {
  padding-left:9px !important;
}
.pr-10 {
  padding-right: 10px;
}
footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  /* background-image: url(/static/images/logos/login_page_bg_image.jpg); */
  background-repeat: no-repeat;
  background-size: auto;
  background-position: bottom;
  background:  #FFFFFF;;
}
.footer_menu {
  padding-left: 0px;
  margin-top: 20px !important;
  margin-left: 0px !important;
  margin-right: 0px !important;
  margin-bottom: 16px !important;
}
.footer-body {
  padding-top:24px;
  padding-bottom: 19px;
}
.footer-text{
  cursor: pointer;
  /* margin-right: 40px; */
  margin-bottom: 0px;
   font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  text-align: right;
  text-decoration-line: underline;
  color: #000001;
}
.footer-copyright {
  color: #000000;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  margin-top: 0px !important;
  margin-left: 0px !important;
  margin-right: 0px !important;
  padding-left:0px;
  /* margin-bottom: 18px !important; */
}
.footer-copyright > li {
  padding-right: 14px;
}
.footer_content {
  text-align: center;
}
.footer_content > ul {
  white-space: nowrap;
  list-style: none;
  margin: 10px;
}
.footer_content > ul > li {
  display: inline;
}
@media only screen and (max-width: 1300px) {
  .hide_xs {
    display: none;
  }
}
</style>
